import { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import QuestDetailTable from "./QuestDetailTable";
import { useGetStudentReportByQuestId } from "../../../../hooks/teacher/students/useGetStudentReportByQuestId";
import TableError from "../../common/TableError";
import StudentCardSkeleton from "./StudentCardSkeleton";
import TableSkeleton from "../../common/TableSkeleton";
import BackButton from "../../../common/BackButton";
import StudentCard from "./StudentCard";
import "./StudentDetail.css";

const QuestDetail = () => {
  const { id, questId } = useParams();
  const location = useLocation();
  const { student } = location.state || {};

  const { report, loading, error, getStudentReportByQuestId } =
    useGetStudentReportByQuestId();

  useEffect(() => {
    getStudentReportByQuestId({ studentId: id, questId: questId });
  }, [id, questId]);

  if (loading && report === undefined) {
    return (
      <div>
        <div className="pb-2">
          <BackButton />
        </div>
        <StudentCardSkeleton />
        <TableSkeleton rows={5} columns={3} />
      </div>
    );
  }

  if (error || report === null) {
    return (
      <TableError
        error={error}
        handleRefresh={() =>
          getStudentReportByQuestId({ studentId: id, questId: questId })
        }
        loading={loading}
      />
    );
  }

  const quest = report?.quest;
  const episodes = report?.episodes || [];

  return (
    <div>
      <div className="pb-2">
        <BackButton />
      </div>

      {/* Student Info Card */}
      <StudentCard student={student} />

      {/* Quest Banner Image */}
      {quest?.banner_img_url && (
        <div className="quest-banner mb-4">
          <img
            src={quest.banner_img_url}
            alt={quest?.title}
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
              borderRadius: "16px",
            }}
          />
        </div>
      )}

      {/* Quest Title & Due Date */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h5 className="mb-0" style={{ color: "var(--text-color)" }}>
          QUEST:{" "}
          <span style={{ fontWeight: "bold" }}>
            {quest?.title?.toUpperCase()}
          </span>
        </h5>
        {/* <p className="mb-0 text-color"> */}
        {/*   DUE DATE: <strong>-</strong> */}
        {/* </p> */}
      </div>

      {/* Episodes Table */}
      <QuestDetailTable episodes={episodes} />
    </div>
  );
};

export default QuestDetail;
